import React, { useEffect, useState } from 'react'
import { Table, TableBody, TableCell, TableHead, TableRow, Tooltip } from '@mui/material'
import { ViewProps } from './types'
import dayjs from 'dayjs'
import style from './YearView.module.css'

type YearViewProps = {} & ViewProps

//TODO Request events here
export function YearView(props: YearViewProps) {
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [years, setYears] = useState<string[]>([])
  const [months, setMonths] = useState<string[]>(
    Array.from({ length: 12 }, (item, i) => {
      return new Date(0, i).toLocaleString('es-ES', { month: 'long' })
    })
  )

  const getDescriptionByName = (e: string) => {
    let description = ''
    if (props.handlerTooltip) {
      let aux = props.handlerTooltip.get(e)
      if (aux) {
        description = aux
      }
    }
    return description
  }

  useEffect(() => {
    if (isLoading) {
      const newYears: string[] = []
      props.events?.map((e) => {
        if (!newYears.includes(dayjs(e.startDate).format('YYYY'))) {
          newYears.push(dayjs(e.startDate).format('YYYY'))
        }
      })
      newYears.sort()
      setYears([...newYears])
    }
    setIsLoading(false)
  }, [isLoading])

  return (
    <>
      <Table style={{ tableLayout: 'fixed' }}>
        <TableHead>
          <TableRow className={style.yearHeader}>
            <TableCell />
            {years.map((year) => (
              <TableCell key={year} size={'small'}>
                <div className={style.yearContainer}>{year}</div>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {months.map((month) => (
            <TableRow key={month} className={style.monthRow} hover={true}>
              <TableCell align={'left'} size={'medium'}>
                <div className={style.monthContainer}>{month.toUpperCase()}</div>
              </TableCell>
              {years.map((year) => (
                <TableCell key={month + year} className={style.tableRows}>
                  {props.events?.map(
                    (e) =>
                      dayjs(e.startDate).format('YYYY') === year.toString() &&
                      dayjs(e.startDate).locale('es').format('MMMM').toUpperCase() ===
                        month.toUpperCase() && (
                        <Tooltip title={getDescriptionByName(e.description)}>
                          <div className={style.monthEvent} key={e.id}>
                            {e.description}
                          </div>
                        </Tooltip>
                      )
                  )}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  )
}
